// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wmklI","rootNoMargin":"styles_rootNoMargin__27jOx"};